import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Avatar from '@material-ui/core/Avatar';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ReactHtmlParser from 'react-html-parser';

const StyledDialog = withStyles(() => ({
  paper: {
    display: 'flex',
    alignItems: 'center',
    padding: '26px 24px',
  },
}))(Dialog);

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100%;
`;

const StyledIconButton = withStyles(() => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}))(IconButton);

const StyledAvatar = withStyles(() => ({
  root: {
    height: '64px',
    width: '64px',
    marginTop: '24px',
  },
}))(Avatar);

const NameContainer = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  color: #484848;
  margin-top: 16px;
  max-width: 100%;
`;

const CompanyTitleContainer = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  color: #484848;
  margin-top: 8px;
  max-width: 100%;
`;

const BioContainer = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #484848;
  margin-top: 24px;
  text-align: justify;
  max-width: 100%;
`;

const SpeakerBioModal = ({
  open,
  onClose,
  name,
  company,
  title,
  avatar,
  bio,
}) => {
  const isMobile = useMediaQuery('(max-width: 960px)');

  return (
    <StyledDialog
      fullScreen={isMobile}
      open={open}
      onClose={onClose}
    >
      <StyledModalContent>
        <StyledIconButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </StyledIconButton>
        <StyledAvatar alt={name} src={avatar} />
        <NameContainer>
          { name }
        </NameContainer>
        <CompanyTitleContainer>
          { company }
        </CompanyTitleContainer>
        <CompanyTitleContainer>
          { title }
        </CompanyTitleContainer>
        <BioContainer>
          { ReactHtmlParser(bio) }
        </BioContainer>
      </StyledModalContent>
    </StyledDialog>
  );
};

SpeakerBioModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  name: PropTypes.string,
  company: PropTypes.string,
  title: PropTypes.string,
  avatar: PropTypes.string,
  bio: PropTypes.string,
};

SpeakerBioModal.defaultProps = {
  open: false,
  onClose: () => {},
  name: '',
  company: '',
  title: '',
  avatar: '',
  bio: '',
};

export default SpeakerBioModal;
